<template>

<main class="lg:mb-[600px] relative z-10 bg-backgroundBody dark:bg-dark">
<!--=====================================
   SEO Hero Section
======================================-->
<section
  class="pt-32 lg:pt-[140px] xl:pt-[180px] pb-7 md:pb-16 lg:pb-[88px] xl:pb-[100px] relative overflow-hidden"
>
  <!-- Hero Content Wrapper -->
  <div
    class="flex flex-col gap-y-8 xl:flex-row justify-center md:justify-between items-center pl-10 reveal-me"
  >
    <!-- Text Content Container -->
    <div class="container max-sm:!-ml-[5%] lg:!ml-[10%] xl:!ml-[7%]">
      <!-- Agency Label -->
      <p
        class="flex gap-5 items-center max-md:justify-center font-poppins text-sm font-normal leading-6 tracking-[3px] uppercase"
      >
      Turn missed leads into booked appointments.
      </p>

      <!-- Responsive Headings -->
      <h1 class="mt-2 sm:mt-6 md:hidden block">
        We are the brilliants in terms of digital marketing
      </h1>
      <h1
        class="mt-6 text-5xl font-semibold lg:text-6xl xl:text-7xl hidden md:block"
      >
        Simple, done-for-you<br> appointment setting and<br>lead follow-up.
      </h1>

      <!-- Hero Buttons -->
      <ul class="flex justify-start list-none mt-14">
        <!-- Primary CTA Button -->
        <li class="block md:inline-block w-full text-center md:w-auto">
          <router-link
            to="/contact"
            class="rv-button rv-button-primary block md:inline-block"
          >
            <div class="rv-button-top">
              <span>Book More Appointments.</span>
            </div>
            <div class="rv-button-bottom">
              <span class="text-nowrap">Book More Appointments.</span>
            </div>
        </router-link>
        </li>
      </ul>
    </div>

    <!-- Hero Image -->
    <figure>
      <img src="@/assets/images/home-5/hero-img.jpg" alt="Hero Img" />
    </figure>
  </div>
</section>


 <!--==================================
   About Description Section Area
===================================-->
<section
    class="pb-14 md:pb-16 lg:pb-[88px] xl:pb-[100px] pt-28 md:pt-32 lg:pt-44 xl:pt-[200px] relative overflow-hidden about"
  >
    <div class="container">
      <!-- Content Wrapper -->
      <div
        class="flex flex-col items-center lg:items-stretch justify-center lg:justify-normal reveal-me"
      >
  
        <!-- About Description -->
        <h4 class="mt-[34px] mx-auto reveal-text relative overflow-hidden">
            We handle the follow-up so you don’t lose leads.  
            <br class="hidden sm:block" />
            From new inquiries to past customers, our team  
            <br class="hidden sm:block" />
            makes the calls that turn interest into appointments.  
            <br />
            <br />
            It’s the easiest way to grow without extra workload  
            <br class="hidden sm:block" />
            on your team.
        </h4>
      </div>
    </div>
  </section>


 <section
  class="pb-14 pt-14 md:pb-16 md:pt-16 lg:pb-[88px] lg:pt-[88px] xl:pb-[100px] xl:pt-[100px] video-section"
>
  <div class="container">
    <!-- Section Header -->
    <div class="mb-10 lg:mb-20">
      <p
        class="font-satoshi text-center text-sm font-normal leading-6 tracking-[3px] uppercase reveal-me"
      >
        OUTCOME
      </p>
      <h2 class="mt-3 lg:mt-5 text-center text-appear">
        Proven to book more<br class="hidden md:block" /> appointments 
      </h2>
      <p class="text-center text-appear mt-1.5">
        Our clients see fuller calendars, higher conversion rates, and more revenue without hiring extra staff.
      </p>
    </div>
    <div class="hero-video-container flex justify-center">
        <figure class="overflow-hidden">
          <img
            src="@/assets/images/home-5/success.jpg"
            alt=""
            class="w-full cursor-pause"
          />
        </figure>
    </div>
  </div>
</section>


 <section
  class="pb-14 pt-14 md:pb-16 md:pt-16 lg:pb-[88px] lg:pt-[88px] xl:pb-[100px] xl:pt-[100px]"
>
  <div class="container">
    <!-- Section Header -->
    <div class="mb-10 lg:mb-20">
      <p
        class="font-satoshi text-center text-sm font-normal leading-6 tracking-[3px] uppercase reveal-me"
      >
        Why Choose US
      </p>
      <h2 class="mt-3 lg:mt-5 text-center text-appear">
        Proven Results for Growing Businesses
       </h2>
    </div>

    <!--  -->

    <div class="flex flex-col md:flex-row " style="gap: 30px; justify-content: space-between;">
      <div class="md:w-1/2">
        <div class="reveal-me">
          <h5 class="py-[30px] pr-[30px]">Profitable in 90 Days.</h5>
        </div>
        <div class="reveal-me">
          <h5 class="py-[30px] pr-[30px]">Scalable, fair pricing.</h5>
        </div>
        <div class="reveal-me">
          <h5 class="py-[30px] pr-[30px]">Quality calls & follow-up</h5>
        </div>
        <div class="reveal-me">
          <h5 class="py-[30px] pr-[30px]">Growth-focused team</h5>
        </div>
      </div>
      <figure class="md:w-1/2 reveal-me">
        <img
          src="@/assets/images/home-5/why-us.jpg"
          alt="Marketing professional"
          class="w-full h-full"
        />
      </figure>
    </div>
  </div>
</section>


 <!--=====================================
   SEO Process Section
======================================-->
<section
  class="pt-14 md:pt-16 lg:pt-[88px] xl:pt-[100px] pb-14 md:pb-16 lg:pb-[88px] xl:pb-[100px]"
>
  <div class="container">
    <!-- Section Header -->
    <div class="">
      <p
        class="font-satoshi text-center text-sm font-normal leading-6 tracking-[3px] uppercase reveal-me mb-2 lg:mb-3"
      >
        Our Process
      </p>
      <h2 class="mb-10 lg:mb-20 text-center text-appear">
        A simple, effective process<br> to keep your calendar full
      </h2>
    </div>

    <!-- Process Steps Container -->
    <div
      class="flex max-md:flex-wrap gap-[30px] justify-center service-item-wrapper"
    >
      <!-- Step 1 - Keyword Research -->
      <div
        class="flex flex-col justify-center items-center relative reveal-me pt-[100px]"
      >
        <h2 class="service-item-number"></h2>
        <h5 class="mb-5">Lead Capture</h5>
        <p class="text-center">We take your inbound leads, past customers, or lists you already have.</p>
      </div>

      <!-- Step 2 - Link Building -->
      <div
        class="flex flex-col justify-center items-center relative reveal-me pt-[100px]"
      >
        <h2 class="service-item-number"></h2>
        <h5 class="mb-5">Follow-Up & Calls</h5>
        <p class="text-center">Our trained callers reach out, reschedule, and nurture every lead.</p>
      </div>

      <!-- Step 3 - Ranking -->
      <div
        class="flex flex-col justify-center items-center relative reveal-me pt-[100px]"
      >
        <h2 class="service-item-number"></h2>
        <h5 class="mb-5">Booked Appointments</h5>
        <p class="text-center">We place confirmed appointments directly on your calendar.</p>
      </div>
    </div>
  </div>
</section>


<!--=====================================
   FAQ Section
======================================-->
<section
  class="pt-14 md:pt-16 lg:pt-[88px] xl:pt-[100px] pb-14 md:pb-16 lg:pb-[88px] xl:pb-[100px] relative overflow-hidden"
>
  <div class="container">
    <!-- Section Heading and Description -->
    <div
      class="flex flex-col md:flex-row gap-x-10 gap-y-5 justify-center lg:justify-between max-md:items-start md:items-end mb-10 lg:mb-20"
    >
      <!-- Section Heading -->
      <div class="flex-1">
        <h2 class="text-appear block md:hidden">
          <span class="font-instrument italic">People</span>
          Asked Us
        </h2>
        <h2 class="text-appear md:block hidden">
          <span class="font-instrument lg:text-[70px] italic">People</span>
          <br />
          Asked Us
        </h2>
      </div>
    </div>

    <!-- FAQ Accordion Items -->
    <div
      class="w-full mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px] items-start"
    >
    <!-- GRID WRAPPER -->
    <div v-for="(item, index) in faqs" :key="index" class="reveal-me">
  <div
    class="accordion-itemV4 overflow-hidden relative w-full bg-backgroundBody dark:bg-dark border
           data-[active=true]:border-black data-[active=false]:border-black/10
           dark:data-[active=false]:border-white/10 dark:data-[active=true]:border-white/10
           duration-300 px-4 md:px-[30px] pt-4 md:pt-[30px] pb-4 space-y-4"
    :data-active="open[index] ? 'true' : 'false'"
  >
    <button
      class="accordion-headerV4 cursor-pointer flex items-center justify-between w-full text-left"
      @click="toggle(index)"
      :aria-expanded="open[index] ? 'true' : 'false'"
      :aria-controls="`faq-body-${index}`"
    >
      <h3 class="text-[23px] md:text-[25px] tracking-normal font-normal md:leading-[25.2px]">
        {{ item.q }}
      </h3>
      <span
        class="transition-transform duration-300 ease-in-out select-none"
        :class="open[index] ? 'rotate-45' : 'rotate-0'"
        aria-hidden="true"
      >+</span>
    </button>

    <!-- Smooth max-height transition -->
    <div
      class="accordion-bodyV4 overflow-hidden transition-[max-height] duration-500 ease-in-out will-change-[max-height]"
      :id="`faq-body-${index}`"
      :style="{ maxHeight: open[index] ? (bodyHeights[index] + 'px') : '0px' }"
      :ref="el => setBodyRef(index, el)"
    >
      <p class="pt-2 md:pt-4">
        {{ item.a }}
      </p>
    </div>
  </div>
</div>

    </div>
  </div>
</section>

<section
    class="pt-14 md:pt-16 lg:pt-[88px] xl:pt-[100px] pb-[70px] lg:pb-[140px] relative"
  >
    <div class="container">
      <!-- CTA Heading -->
      <h2
        class="text-center xl:text-[96px] font-normal xl:leading-[1.1] xl:tracking-[-2.88px]"
      >
        Got Questions?
        <span class="font-instrument sm:mt-10 italic block max-md:inline-block"
          >We’ve Got Answers</span
        >
      </h2>
  
      <ul
      class="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-6 list-none"
    >
        <!-- Primary CTA Button -->
        <li
          class="block md:inline-block w-[90%] mx-auto md:ml-auto md:mr-0 md:w-auto"
        >
        
        </li>
        <!-- Secondary CTA Button -->
        <li
          class="block md:inline-block w-[90%] mx-auto md:mr-auto md:ml-0 md:w-auto"
        >
          <router-link
            to="/contact"
            class="rv-button rv-button-primary block md:inline-block"
          >
            <div class="rv-button-top contact-btn-lg">
              <span>Let's Connect</span>
            </div>
            <div class="rv-button-bottom contact-btn-lg">
              <span>Let's Connect</span>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
  </section>
</main>

<!--=====================================
   Footer Section
======================================-->
<FooterComponent/>


<!---Modal -->
<div
  aria-hidden="false"
  class="fixed z-[99999999990] hidden inset-0 top-6 items-start justify-center bg-metal-900 bg-dark-200/25"
  onclick="javascript.void(0)"
  id="modal"
  role="dialog"
>
  <div class="relative w-full p-4 h-auto animate-keep-bounce max-w-xl">
    <div class="relative bg-white dark:bg-dark p-2.5">
      <div class="p-10 max-lg:p-5">
        <div class="flex items-center justify-between pb-5">
          <h5 class="text-secondary dark:text-backgroundBody">Search</h5>
          <button class="text-secondary dark:text-backgroundBody" id="ok-btn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="30"
              height="30"
              viewBox="0 0 50 50"
            >
              <path
                d="M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z"
                class="fill-secondary dark:fill-backgroundBody"
              ></path>
            </svg>
          </button>
        </div>
        <form class="mt-5">
          <div>
            <div class="flex">
              <div class="relative w-full">
                <input
                  class="block w-full focus:outline-none focus:ring-0 text-secondary dark:text-backgroundBody border py-3.5 px-5 dark:border-dark bg-transparent placeholder:text-secondary/50 dark:placeholder:text-backgroundBody/50 outline-none focus:border-primary dark:focus:border-primary duration-300 transition-all"
                  id="#id-10"
                  placeholder="Search RIVOR Component"
                  type="text"
                  value=""
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { Animations } from '@/legacy/initLegacy';
import FooterComponent from '@/components/FooterComponent.vue';

export default {
  name: 'LeadGenPage',
  components: { FooterComponent },

  data() {
    return {
      open: {}, // {0:true, 1:false, ...}
      faqs: [
        { q: "Do you offer a trial period?",
          a: "Yes — we provide a 2-week free trial so you can experience the results before committing." },
        { q: "Who makes the calls — is it outsourced?",
          a: "You’ll have a dedicated caller that we train, manage, and quality-check. They work as an extension of your practice, introducing themselves as part of your office." },
        { q: "Will patients know it’s not our staff?",
          a: "No. Our callers represent your practice directly. With custom scripts and training, every interaction feels seamless and professional." },
        { q: "How quickly will we see results?",
          a: "Most practices begin seeing reactivations and reschedules within the first 2–3 weeks." },
        { q: "Do you follow HIPAA and compliance standards?",
          a: "Yes. We operate under strict compliance procedures to ensure patient information is always protected." },
        { q: "Do you also handle new leads, or just existing patients?",
          a: "Both. We can follow up on new inquiries to prevent leads from going cold, and we specialize in reactivating past patients who haven’t been back in a while." }
      ],
      bodyRefs: [],   // per-item refs
      bodyHeights: [] // per-item measured heights
    };
  },

  methods: {
    // Smooth open/close with true height measurement
    toggle(index) {
      if (!this.open[index]) {
        // OPEN: measure, animate 0 -> height
        this.open[index] = true;
        this.$nextTick(() => {
          const h = this.getScrollHeight(index);
          this.bodyHeights[index] = 0;
          requestAnimationFrame(() => { this.bodyHeights[index] = h; });
        });
      } else {
        // CLOSE: set current height, then animate height -> 0
        const h = this.getScrollHeight(index);
        this.bodyHeights[index] = h;
        requestAnimationFrame(() => {
          this.bodyHeights[index] = 0;
          this.open[index] = false;
        });
      }
    },

    setBodyRef(index, el) {
      if (el) {
        this.bodyRefs[index] = el;
        // pre-measure once; start closed visually
        this.$nextTick(() => {
          const h = this.getScrollHeight(index);
          this.bodyHeights[index] = h;
        });
      }
    },

    getScrollHeight(index) {
      const el = this.bodyRefs[index];
      if (!el) return 0;
      const prev = el.style.maxHeight;
      el.style.maxHeight = 'none';
      const h = el.scrollHeight;
      el.style.maxHeight = prev || '0px';
      return h;
    }
  },

  mounted() {
    Animations.initTextReveal();
    // initial measurement after render
    this.$nextTick(() => this.faqs.forEach((_, i) => {
      const h = this.getScrollHeight(i);
      this.bodyHeights[i] = h || 0;
    }));
  },

  activated() {
    this.$nextTick(() => { Animations.initTextReveal(); });
  },

  watch: {
    $route() {
      this.$nextTick(() => { Animations.initTextReveal(); });
    }
  }
};
</script>
